
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/viber",
      function () {
        return require("private-next-pages/android/local/viber/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/viber"])
      });
    }
  